/**
 * @desc 获取设备名称
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** 设备编码 */
  assetCode: string;
}

export function request(
  params: Params,
): Promise<defs.StandardReturn<Array<defs.IotAssetResult>>> {
  return defHttp.get({
    url: '/web/alert/rule/queryAsset',

    params,
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<Array<defs.IotAssetResult>>> {
  return defHttp.get({
    url: '/mock/web/alert/rule/queryAsset',

    params,
  });
}
